import {
  ClientId,
  HandshakeInit,
  HandshakeResult,
  IMessage,
  RequestTopicSubscriptionsPayload,
  TopicSubscribePayload,
  TopicSubscriptions,
  TopicUnsubscribePayload,
  UUID,
  BrokerId,
} from 'magpie-types';
import { defineMessage } from '../internal-messaging';

type ReplyTo<T> = T & { replyTo: UUID };

// Ping to check if window/scope has a relay
const probe = defineMessage('cd-relay/probe' as const);
const probeReply = defineMessage(
  'cd-relay/probe-reply' as const,
  (payload: ReplyTo<{ brokerId: BrokerId }>) => payload
);

const handshake = defineMessage(
  'cd-relay/handshake' as const,
  (payload: HandshakeInit) => payload
);
const handshakeResponse = defineMessage(
  'cd-relay/handshake-response' as const,
  (payload: ReplyTo<HandshakeResult>) => payload
);
const topicSubscribe = defineMessage(
  'cd-relay/topic-subscribe' as const,
  (payload: TopicSubscribePayload) => payload
);
const topicUnsubscribe = defineMessage(
  'cd-relay/topic-unsubscribe' as const,
  (payload: TopicUnsubscribePayload) => payload
);
const getTopicSubscriptions = defineMessage(
  'cd-relay/getTopicSubscriptions' as const,
  (payload: RequestTopicSubscriptionsPayload) => payload
);
const getTopicSubscriptionsResponse = defineMessage(
  'cd-relay/getTopicSubscriptionsResponse' as const,
  (payload: ReplyTo<TopicSubscriptions>) => payload
);
const close = defineMessage(
  'cd-relay/close' as const,
  (payload: { clientId: ClientId }) => payload
);
const sendMessage = defineMessage(
  'cd-relay/sendMessage' as const,
  (message: IMessage) => message
);
const relayMessage = defineMessage(
  'cd-relay/relayMessage' as const,
  (message: IMessage) => message
);

// Response to an operation that doesn't require specific payload response but we want to know was performed successfully
const opCompletedConfirmation = defineMessage(
  'cd-relay/operation-completed-confirmation' as const,
  (requestId: UUID) => requestId
);

const opFailedConfirmation = defineMessage(
  'cd-relay/operation-failed-confirmation' as const,
  (payload: ReplyTo<{ error: Error }>) => payload
);

export const relayOperations = {
  probe,
  probeReply,
  handshake,
  handshakeResponse,
  topicSubscribe,
  topicUnsubscribe,
  getTopicSubscriptions,
  getTopicSubscriptionsResponse,
  close,
  sendMessage,
  relayMessage,
  opCompletedConfirmation,
  opFailedConfirmation,
};
